module.exports = __webpack_public_path__ + "static/media/projects3.ddb04bb5.png";